import { Button, ButtonGroup, Tooltip } from '@chakra-ui/react'
import { useIntl } from 'react-intl'
import messages from './messages'

interface Props {
  onAddPatientClick: () => void
  onAddVisitClick?: () => void
  onAddFollowUpClick?: () => void
  isPatientSelected?: boolean
  disablePatientCreate?: boolean
  disableVisitCreate?: boolean
}

export default function ActionBar({
  onAddPatientClick,
  onAddVisitClick,
  onAddFollowUpClick,
  isPatientSelected = false,
  disablePatientCreate = false,
  disableVisitCreate = false
}: Props) {
  const { formatMessage } = useIntl()
  const limitLabel = formatMessage(messages.freeUsageLimitReached)

  return (
    <ButtonGroup
      spacing={2}
      bg="transparent"
      sx={{
        '& > span': {
          display: 'inline-flex'
        },
        '& button': {
          borderRadius: '10px',
          boxShadow: '0 8px 22px rgba(0, 0, 0, 0.14)'
        },
        '& button:disabled': {
          boxShadow: '0 5px 14px rgba(0, 0, 0, 0.08)'
        }
      }}
    >
      <Tooltip
        label={disablePatientCreate ? limitLabel : undefined}
        hasArrow
        shouldWrapChildren
      >
        <Button
          colorScheme="gray"
          onClick={onAddPatientClick}
          isDisabled={disablePatientCreate}
        >
          {formatMessage(messages.addPatient)}
        </Button>
      </Tooltip>
      {isPatientSelected && (
        <Tooltip
          label={disableVisitCreate ? limitLabel : undefined}
          hasArrow
          shouldWrapChildren
        >
          <Button onClick={onAddVisitClick} isDisabled={disableVisitCreate}>
            {formatMessage(messages.visit)}
          </Button>
        </Tooltip>
      )}
      {isPatientSelected && (
        <Tooltip
          label={disableVisitCreate ? limitLabel : undefined}
          hasArrow
          shouldWrapChildren
        >
          <Button onClick={onAddFollowUpClick} isDisabled={disableVisitCreate}>
            {formatMessage(messages.followUp)}
          </Button>
        </Tooltip>
      )}
    </ButtonGroup>
  )
}
